import { api } from './api';

export interface FactoriesStatus {
  enabled: boolean;
  editorias: {
    slug: string;
    nome: string;
    modo: string;
    fabrica: string | null;
    sites: string[];
    status: string | null;
  }[];
  materias_publicadas: number;
  materias_por_site: Record<string, number>;
  jogos_validos: string[];
}

export interface FactoriesRunResult {
  skipped?: string;
  runs?: {
    editoria: string;
    wp_site: string;
    loterias?: { game: string; wp_link?: string }[];
    mercado?: { wp_link?: string }[];
    clima?: { wp_link?: string }[];
  }[];
}

export const factoriesApi = {
  getStatus: (): Promise<FactoriesStatus> => api.get<FactoriesStatus>('/factories/status'),
  runNow: (): Promise<FactoriesRunResult> => api.post<FactoriesRunResult>('/factories/run'),
  runEditoria: (slug: string, client?: string): Promise<FactoriesRunResult> => {
    const query = client ? `?client=${encodeURIComponent(client)}` : '';
    return api.post<FactoriesRunResult>(`/factories/run/${slug}${query}`);
  },
  previewCover: (slug: string): Promise<{ png_base64: string }> =>
    api.get<{ png_base64: string }>(`/factories/preview/${slug}`),
};
